import React, { useEffect, useLayoutEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import './style.scss'

export default function MenuShareTemplate({
  isOpen = true,
  onClose,
  onDownloadExcel,
  // onDownloadPDF,
  onUseAsTemplate,
  position,
  style = {},
  className = '',
  id = 'share-template-menu',
}) {
  const menuRef = useRef(null)

  useLayoutEffect(() => {
    if (!isOpen) return

    const adjustPosition = () => {
      const el = menuRef.current
      if (!el) return

      el.style.transform = ''
      const rect = el.getBoundingClientRect()
      const padding = 8

      if (rect.left < padding) {
        const offset = padding - rect.left
        el.style.transform = `translateX(${offset}px)`
      } else if (rect.right > window.innerWidth - padding) {
        const offset = rect.right - (window.innerWidth - padding)
        el.style.transform = `translateX(-${offset}px)`
      }
    }

    adjustPosition()
    window.addEventListener('resize', adjustPosition)
    return () => {
      window.removeEventListener('resize', adjustPosition)
    }
  }, [isOpen])

  useEffect(() => {
    if (!isOpen) return

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose?.()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  const handleItemClick = (e, callback) => {
    e.preventDefault()
    e.stopPropagation()
    callback?.(e)
    onClose?.()
  }

  const combinedStyle = {
    ...position,
    ...style,
  }

  return (
    <div
      id={id}
      ref={menuRef}
      className={`share-template-menu ${className}`.trim()}
      style={combinedStyle}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="share-template-menu__item"
        onClick={(e) => handleItemClick(e, onDownloadExcel)}
      >
        <span className="share-template-menu__icon">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
          </svg>
        </span>
        <span className="share-template-menu__label">Download as Excel</span>
      </div>

      {/* <div
        className="share-template-menu__item"
        onClick={(e) => handleItemClick(e, onDownloadPDF)}
      >
        <span className="share-template-menu__icon">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
          </svg>
        </span>
        <span className="share-template-menu__label">Download as PDF</span>
      </div> */}

      <div
        className="share-template-menu__item"
        onClick={(e) => handleItemClick(e, onUseAsTemplate)}
      >
        <span className="share-template-menu__icon">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 4h16v16H4z" />
            <path d="M4 9h16" />
            <path d="M9 4v16" />
          </svg>
        </span>
        <span className="share-template-menu__label">Use as template</span>
      </div>
    </div>
  )
}

MenuShareTemplate.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onDownloadExcel: PropTypes.func,
  onDownloadPDF: PropTypes.func,
  onUseAsTemplate: PropTypes.func,
  position: PropTypes.shape({
    top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    right: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}
